import { useAuthStore } from '@/modules/auth/store/auth';

export default defineNuxtRouteMiddleware(async (to, from) => {
  const { isCustomer } = useAuthStore();

  if (!isCustomer) {
    return navigateTo('/');
  }
});
